var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetachedHouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 53,
    viewBox: "0 0 64 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M64 25.7L32.1 0L31.5 0.5C28.3 3 24.8 5.9 21.2 8.8V2.8H12.4V15.9C5.8 21.2 0.5 25.4 0 25.7C0 25.7 0.1 25.7 0.2 25.6L0.8 27.5C1 27.4 1.2 27.4 7.6 22.2V52.5H26.6V37.3H36.7V52.5H55.9V21.7L62.7 27.2L64 25.7ZM14.4 4.7H19.2V10.4C17.6 11.7 16 13 14.4 14.3V4.7ZM54 50.6H38.7V35.4H24.7V50.6H9.6V20.7C11.6 19.1 14.1 17.1 17.1 14.7C23.6 9.5 30.1 4.2 32.1 2.6L54 20.1V50.6Z",
    fill: "#182F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetachedHouse);
export default __webpack_public_path__ + "static/media/detached_house.f303cdb1.svg";
export { ForwardRef as ReactComponent };